import { render } from "./BackButton.vue?vue&type=template&id=c105d7d8&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=c105d7d8&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\kmrtt\\20240208サイトデータ修正\\k_5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c105d7d8"]])

export default __exports__